import React, {useEffect} from "react";
import {Chart} from "./chart";
import {NO_STRATEGY_KEY, useRootStore} from "../stores/rootStore";
import {ChartStoreProvider} from "../stores/chartStore";
import {observer} from "mobx-react";
import {isMobile} from "react-device-detect";

export const Root = observer(function Root() {
  const rootStore = useRootStore()

  const {
    init,
    settingsLoadingError,
    settingsLoading,
    selectedStrategyKey,
    selectedChartStore,
    strategies,
    setSelectedChartKey,
  } = rootStore

  useEffect(init, [])

  return (
    <div className='wem-chart-root' style={{minHeight: isMobile ? 468 : 658}}>
      {settingsLoading ? (
        <div>
          Loading
        </div>
      ) : settingsLoadingError ? (
        <div>
          <p>Got an error while loading settings: "{settingsLoadingError}".</p>
          <p>This is not expected. Please contact wem-chart plugin developers about it.</p>
        </div>
      ) : selectedChartStore ? (
        <div>
          <div className='wem-chart-strategy-select-container'>
            <select
              value={selectedStrategyKey}
              onChange={event => setSelectedChartKey(event.target.value)}
              disabled={!strategies}
            >
              {strategies ? strategies.map(({name}, key) => (
                <option key={key} value={key}>{name}</option>
              )) : (
                <option value={NO_STRATEGY_KEY}>----</option>
              )}
            </select>
          </div>
          <ChartStoreProvider store={selectedChartStore}>
            <Chart/>
          </ChartStoreProvider>
        </div>
      ) : (
        <div>
          No chart data files loaded. Please configure at least one.
        </div>
      )}
    </div>
  )
})
